import React from 'react';
import PropTypes from 'prop-types';

import Questionnaire from '../Questionnaire/QuestionnairePage';

// rotas que precisam de token
const PublicQuestionnairePage = ({
  match,
  history,
}) => {
  const {
    enrollmentId,
    applicationQuestionnaireToken,
  } = history.location.state;

  return (
    <Questionnaire
      isPublic
      match={match}
      history={history}
      enrollmentId={enrollmentId}
      applicationQuestionnaireToken={applicationQuestionnaireToken}
    />
  );
};

PublicQuestionnairePage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default PublicQuestionnairePage;
